import React from "react"
import { getHomeRoute } from "utils/utils"

export class Home extends React.Component {
  render() {
    if (!this.props.user.loading) {
      const homePath = getHomeRoute(this.props.user, this.props.organization)
      if (homePath.pathname) {
        this.props.history.push({
          ...homePath,
        })
      } else {
        this.props.history.push(homePath)
      }
    }
    return <div></div>
  }
}

export default Home
